import { Children, cloneElement, useId } from 'react';
import { cx } from './utils';

/**
 * Associates a single input-like child with its label, hint, and error text.
 * If no label is supplied, the child must provide an accessible name itself.
 */
export default function Field({
  children,
  className,
  error,
  hint,
  id,
  label,
  labelClassName,
}) {
  const generatedId = useId();
  const inputId = id || generatedId;
  const hintId = hint ? `${inputId}-hint` : undefined;
  const errorId = error ? `${inputId}-error` : undefined;
  const describedBy = [hintId, errorId].filter(Boolean).join(' ') || undefined;
  const control = Children.only(children);

  const enhancedControl = cloneElement(control, {
    id: control.props.id || inputId,
    'aria-describedby': [control.props['aria-describedby'], describedBy].filter(Boolean).join(' ') || undefined,
    'aria-invalid': error ? true : control.props['aria-invalid'],
  });

  return (
    <div className={cx('ui-field', className)}>
      {label && <label htmlFor={inputId} className={cx('ui-field__label', labelClassName)}>{label}</label>}
      {enhancedControl}
      {hint && <p id={hintId} className="ui-field__hint">{hint}</p>}
      {error && <p id={errorId} className="ui-field__error" role="alert">{error}</p>}
    </div>
  );
}
